import { useEffect, useRef } from 'react';
import { Container } from '@pixi/react';
import { isMobile } from '../../../helpers/isMobile';
import { gameResourcesService } from '../../services/gameResourcesService';
import { Spine } from '../spine';
import { slotSpineKey } from '../../../constants/symbolsNames';

// RU: надпись «RESPIN» над доской — играет на каждом шаге серии респинов
//     (gameModuleService.startReSpinTextAnimation). Декор: вне хит-теста.
export const ReSpinText = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const spine = new Spine({ key: slotSpineKey.reSpinText });
    spine.position.set(isMobile() ? 270 : 720, 405);
    gameResourcesService.setReSpinText(spine);
    containerRef.current.addChild(spine);
    return () => {
      gameResourcesService.setReSpinText(null);
      if (!spine.destroyed) spine.destroy({ children: true });
    };
  }, []);

  return <Container name="ReSpinText" eventMode="none" ref={containerRef} />;
};
